import React, { useState, useEffect } from 'react';
import Icon from '../AppIcon';
import Button from './Button';

const ConfirmationDialog = ({
  title,
  message,
  confirmText,
  cancelText,
  type,
  onConfirm,
  onCancel
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const handleConfirm = () => {
    setIsVisible(false);
    setTimeout(() => onConfirm?.(), 150);
  };

  const handleCancel = () => {
    setIsVisible(false);
    setTimeout(() => onCancel?.(), 150);
  };

  const getDialogConfig = () => {
    switch (type) {
      case 'danger': case'error':
        return {
          icon: 'AlertTriangle',
          iconColor: 'text-error',
          iconBg: 'bg-error/10 dark:bg-error/20',
          confirmVariant: 'danger'
        };
      case 'warning':
        return {
          icon: 'AlertTriangle',
          iconColor: 'text-warning',
          iconBg: 'bg-warning/10 dark:bg-warning/20',
          confirmVariant: 'warning'
        };
      case 'info':
        return {
          icon: 'Info',
          iconColor: 'text-primary',
          iconBg: 'bg-primary/10 dark:bg-primary/20',
          confirmVariant: 'default'
        };
      default:
        return {
          icon: 'HelpCircle',
          iconColor: 'text-primary',
          iconBg: 'bg-primary/10 dark:bg-primary/20',
          confirmVariant: 'default'
        };
    }
  };

  const config = getDialogConfig();

  return (
    <div 
      className={`
        fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4
        transition-all duration-300 ease-out
        ${isVisible ? 'opacity-100' : 'opacity-0'}
      `}
      onClick={handleCancel}
    >
      <div
        className={`
          bg-surface rounded-lg shadow-elevated border border-border max-w-md w-full
          transform transition-all duration-300 ease-out
          ${isVisible ? 'scale-100 opacity-100' : 'scale-95 opacity-0'}
        `}
        onClick={(e) => e?.stopPropagation()}
      >
        <div className="p-6">
          {/* Header */}
          <div className="flex items-center space-x-4 mb-4">
            <div className={`w-12 h-12 rounded-full flex items-center justify-center ${config?.iconBg}`}>
              <Icon 
                name={config?.icon} 
                size={24} 
                className={config?.iconColor} 
              />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-text-primary">
                {title}
              </h3>
            </div>
          </div>

          {/* Message */}
          <div className="mb-6">
            <p className="text-text-secondary leading-relaxed">
              {message}
            </p>
          </div>

          {/* Actions */}
          <div className="flex items-center justify-end space-x-3">
            <Button
              variant="outline"
              onClick={handleCancel}
            >
              {cancelText}
            </Button>
            <Button
              variant={config?.confirmVariant}
              onClick={handleConfirm}
            >
              {confirmText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialog;